import React from 'react';

import { TeamsIcon } from '@atlaskit/logo/teams/icon';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration, GlobalShortcutLinkItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';
import { messages } from './messages';

const icon = <TeamsIcon size="xsmall" label="" />;

export const useTeams = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
): GlobalShortcutLinkItem =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.ATLAS_TEAMS,
		analyticsName: Products.ATLAS_TEAMS,
		...options,
	});
